// /**
//  * Bundle - list
//  */

// React
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import HeaderBuilder from '../../utils/headerBuilder';
// Context
import AuthContext from '../../authContext';

// UI
import theme from '../../theme';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  Select,
  TableHead,
  TableSortLabel,
} from '@material-ui/core';

// Components
import Can from '../../components/Can';

// Helper
import { checkMatchMedia, numberWithCommas, translate } from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import stableSort from '../../utils/Table/stableSort'
import getComparator from '../../utils/Table/getComparator'
import RonadIcons from '../../components/iconComponent';
// Type
// import {Bundle} from './interfaces';

type Data = Bundle;
type Props = {
  data: any;
  handleClickOpen: (id: number) => void;
  changeStatus: any;
  handleOpenEdit: (id: number) => void;
};

type Ord = 'asc' | 'desc';

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      textAlign: 'left',
      padding: '10px 14px',
      backgroundColor: '#d3d6e8 !important',
      color: '#212121',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      textAlign: 'left',
      padding: '10px 10px',
      borderRadius: '0',
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      borderRadius: "4px",
      boxShadow: "0 0 24px -8px rgba(0,0,0,0.27)"
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 540,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

// const

const invoicesStatus = [
  'CREATED',
  'PAID',
  'NOT_PAID',
  'CANCELED'
];

function EnhancedTableHead(props: any) {
  const {order, orderBy, onRequestSort, headCells} = props;
  const createSortHandler = (property: keyof Data) => (
    event: React.MouseEvent<unknown>
  ) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            direction={orderBy === headCell.id ? order : 'asc'}
            data-cy={headCell.id}
          >
            <TableSortLabel
              IconComponent={() => (
                <RonadIcons
                  name={
                    orderBy === headCell.id && order === 'desc'
                      ? 'chevronDown'
                      : 'chevronUp'
                  }
                  size={0.7}
                  style={{marginRight: '8px'}}
                />
              )}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <div className={classes.root}>
      <TableContainer component={Paper}>
        <Table
          stickyHeader
          className={classes.table}
          aria-labelledby="tableTitle"
          size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={props.data.length}
            headCells={props.head.headCells}
          />
          <TableBody>
            {stableSort(props.data, getComparator(order, orderBy))
              .slice()
              .map((row: any, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TableRow key={index}>
                    <StyledTableCell align="center">
                      {numberWithCommas(row.amount)}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {numberWithCommas(row.amount - row.insuranceCost - row.damageCost)}
                    </StyledTableCell>
                    <StyledTableCell align="center">{row.id}</StyledTableCell>
                    <StyledTableCell align="center">
                      {jMoment(row.created, 'YYYY/M/D')
                        .locale('fa')
                        .format('jYY/jMM/jDD')}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {decodeURI(row.subject)}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <FormControl style={{ width: '100%' }}>
                        <Can
                          role={authContext.user.role}
                          perform="bundles:changeStatus"
                          yes={() => (
                            <>
                              <RonadIcons name='pencil' className={classes.changStatusIcon}/>
                              <Select
                                className={classes.changStatusBox}
                                fullWidth
                                name={`status${index}`}
                                multiple
                                id={row.rubikaId}
                                value={[{}]}
                                IconComponent={() => null}
                                renderValue={() => (
                                  <span className={classes.renderValue}>
                                    {translate(row.status, 'invoice')}
                                  </span>
                                )}
                              >
                                <RadioGroup
                                  className={classes.radioGroup}
                                  aria-label={`status${index}`}
                                  name={`status${index}`}
                                  value={'item'}
                                  onChange={(
                                    e: React.ChangeEvent<{ value: unknown }>
                                  ) =>
                                    props.changeStatus({
                                      id: row.id,
                                      body: `"${e.target.value}"`,
                                    })
                                  }
                                >
                                  {invoicesStatus.map(
                                    (item: any, index: number) => (
                                      <FormControlLabel
                                        className={classes.radioGroupItem}
                                        key={index}
                                        checked={row.status === item}
                                        value={item}
                                        control={<Radio />}
                                        label={translate(item, 'invoice')}
                                      />
                                    )
                                  )}
                                </RadioGroup>
                              </Select>
                            </>
                          )}
                          no={() => (
                            <span>
                              {translate(row.status, 'invoice')}
                            </span>
                          )}
                        />
                      </FormControl>
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <Link to={`/invoice/${row.id}`}>
                        <IconButton
                          aria-label="bundle"
                          size="small"
                          title="جزئیات فاکتور"
                        >
                          <RonadIcons name='documentOutline' className='text-green'/>
                        </IconButton>
                      </Link>
                      {/* {row.status !== 'PAID' && (
                        <Link to={`/pay-process/${row.id}`}>
                          <IconButton
                            // onClick={() => props.handlePayment(row.id)}
                            size="small"
                            title="پرداخت فاکتور"
                          // disabled={row.status === 'PROCESSED'}
                          >
                            <RonadIcons 
                              style={{color:row.status !== 'PROCESSED' ? theme.palette.blue.main: theme.palette.blue.contrastText}}
                              name='creditCard'
                              size={1}
                            />
                          </IconButton>
                        </Link>
                      )} */}
                    </StyledTableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
